import React, { useCallback, useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { paintDiameterSharedState } from './state';
import { DisplayConfig, Maybe } from '@/__generated__/graphql';
import { INCHES_TO_METERS_FACTOR } from '@/utils/unitSystem';
import { useGetAssemblyPipeSpecLazyQuery } from '@/__generated__/graphql';
import * as state from '@/components/Analysis/state';
import { formatFieldValue } from '@/utils';
import { NOT_APPLICABLE_LABEL } from '@/constants';
import { METERS_TO_INCHES_FACTOR } from '@abyss/3d-viewer';

export type Props = {
  onFieldValueChange?: (value: string) => void;
  title?: string;
  displayConfig?: Maybe<DisplayConfig>;
  value?: string;
};

export const ProposedPaintDiameter = ({
  title,
  displayConfig,
  onFieldValueChange,
  value,
}: Props) => {
  const [paintDiameter, setPaintDiameter] = useAtom(paintDiameterSharedState);
  const rows = displayConfig?.textAreaRows || 4;
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);
  const unitSystem = useAtomValue(state.unitSystem);

  // Local state to manage the display value in the text field
  const [displayValue, setDisplayValue] = useState<string>(
    formatFieldValue({
      unitSystem,
      value: value
        ? String(Number(value) * METERS_TO_INCHES_FACTOR)
        : String(Number(paintDiameter) * METERS_TO_INCHES_FACTOR) ?? NOT_APPLICABLE_LABEL,
      roundToDecimal: 2,
      showUnitLabel: false,
      type: undefined,
    }) ?? NOT_APPLICABLE_LABEL
  );

  const [getAssemblyPipeSpecLazyQuery] = useGetAssemblyPipeSpecLazyQuery();

  const handlePaintDiameter = useCallback(
    (value: string) => {
      const diameterInMeters = String(Number(value) * INCHES_TO_METERS_FACTOR);
      setPaintDiameter(diameterInMeters);
      setDisplayValue(value);
      if (onFieldValueChange !== undefined) {
        onFieldValueChange(diameterInMeters);
      }
    },
    [onFieldValueChange, setPaintDiameter]
  );

  useEffect(() => {
    if (selectedAssemblyId) {
      getAssemblyPipeSpecLazyQuery({
        variables: {
          assemblyId: selectedAssemblyId,
        },
      }).then((response) => {
        const size = response.data?.assembly?.pipeSpec?.size;
        if (size) {
          setPaintDiameter(size);
          handlePaintDiameter(size);
        }
      });
    }
  }, [selectedAssemblyId]);
  return (
    <>
      <Box
        sx={{
          width: '100%',
          '& .MuiTextField-root': { width: '100%' },
        }}
        component="form"
        noValidate
        autoComplete="off"
      >
        <div>
          <TextField
            id={`TextArea-${title}`}
            label={`${title} (in)`}
            multiline={false}
            rows={rows}
            value={isNaN(Number(displayValue)) ? 0 : displayValue}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
              handlePaintDiameter(event.target.value);
            }}
          />
        </div>
      </Box>
    </>
  );
};
